import { gql } from '__generated__';

export default gql(`
  query GetTeamFilters(
    $project_id: ID!,
    $search: String,
    $events: [ID!],
    $team_types: [ID!],
    $min_size: Int,
    $max_size: Int,
  ) {
    project(id: $project_id) {
      id
      team_stats(
        events: $events,
        team_types: $team_types,
        search: $search,
        min_size: $min_size,
        max_size: $max_size,
      ) {
        teams
        registrations
      }
      events(ids: $events) {
        data {
          id
          team_types {
            id
            title
          }
        }
      }
    }
  }
`);
